<template>
  <qx-card title="">
    <section slot="titleLeft">
      <qx-permpisions permpisions>
        <section slot="titleLeft">
        </section>
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
          >
            <section slot-scope="scope" >
              <section v-if="scope.column.property === 'orderId'">
                  <span class="primary cur" @click="toOrderDetail(scope.row)">{{
                      scope.row[scope.column.property]
                    }}</span>
              </section>
              <section v-else-if="scope.column.property === 'grossProfitMargin'">
                  <span class="primary cur">{{scope.row[scope.column.property]  +'%'}}</span>
              </section>
              <section v-else>
                <span>{{ scope.row[scope.column.property] }}</span>
              </section>
            </section>
          </el-table-column>
          <!-- 常规列表项 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import {queryDriverOperateReportDetail} from 'api/report';
export default {
  mixins: [
    tableMixin,
  ],
  data () {
    return {
      searchBoxData: {},
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          { prop: 'dependTimeStr', label: '发车时间'},
          { prop: 'orderId', label: '订单编号' },
          { prop: 'lineName', label: '路线' },
          { prop: 'carDriverMan', label: '主驾姓名' },
          { prop: 'carDriverPhone', label: '主驾电话' },
          { prop: 'copilotMan', label: '副驾姓名' },
          { prop: 'copilotPhone', label: '副驾电话' },
          { prop: 'orgName', label: '归属部门' },
          { prop: 'amountReceivable', label: '应收金额' },
          { prop: 'oilFee', label: '油费' },
          { prop: 'roadAndBridgeFee', label: '路桥费' },
          { prop: 'maintenanceFee', label: '维修保养费' },
          { prop: 'otherExpenses', label: '其他费用' },
          { prop: 'carDriverSalary', label: '主驾工资' },
          { prop: 'copilotSalary', label: '副驾工资' },
          { prop: 'grossProfit', label: '毛利' },
          { prop: 'grossProfitMargin', label: '毛利率' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: queryDriverOperateReportDetail,
    handleBeforeGetData () {
      this.searchBoxData = {
        carDriverPhone: this.$route.query.id,
        dependTimeBegin: this.$route.query.dependTimeBegin !== '' ? this.formatDate(this.$route.query.dependTimeBegin) : '',
        dependTimeEnd: this.$route.query.dependTimeEnd !== '' ? this.formatDate(this.$route.query.dependTimeEnd) : '',
        orgId: this.$route.query.orgId !== -1 ? this.$route.query.orgId : '',
      };
    },
    toOrderDetail (item, defaultActive = '', defaultChildActive = 'carrier') {
      console.log(item.orderId);
      this.jump({
        label: `订单详情-${item.orderId}`,
        url: `/manage/operate/order/deal/orderDetailTab?id=${item.orderId}&defaultActive=${defaultActive}&defaultChildActive=${defaultChildActive}`,
        full: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
